import { render, staticRenderFns } from "./StepFarmerSize.vue?vue&type=template&id=7fabf038&scoped=true&"
import script from "./StepFarmerSize.vue?vue&type=script&lang=js&"
export * from "./StepFarmerSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabf038",
  null
  
)

export default component.exports